import ProfileComponent from "../../../component/profileComponent";

const BCrumb = [
  {
    to: "/app/user-management",
    title: "Home",
  },
  {
    title: "Profile",
  },
];

export default function Profile() {
  return (
    <div className="flex justify-center px-6 py-2 mx-16">
      <div className=" ml-6 w-full max-w-5xl ">
        <ProfileComponent BCrumb={BCrumb} />
      </div>
    </div>
  );
}
